import React from "react"
import DataTable from "../DataTable/DataTable"
import BasePricesDashboardHeader from "./BasePricesDashboardHeader"
import BasePricesDashboardStore from './stores/BasePricesDashboardStore'
import BasePricesDashboardActions from './actions/BasePricesDashboardActions'
import { parseISO } from 'date-fns';

class BasePricesDashboard extends React.Component {
    constructor(props) {
      super(props);
      this.state = this.getStateFromStores()
      this._onChange = this._onChange.bind(this)
    }
  
    componentDidMount() {
      BasePricesDashboardStore.addChangeListener(this._onChange);
      BasePricesDashboardActions.init(this.props);
      if (this.props.currentDate) {
        this.setState({
          afterMount: true
        })
      }
    }
  
    componentDidUpdate(prevProps, prevState) {
      if (this.state.dataTableEndpoint != prevState.dataTableEndpoint) {
        this.refs.dataTable.loadData();
      }
    }
  
  
    getStateFromStores() {
      return {
        currentDate: BasePricesDashboardStore.getCurrentDate(),
        dataTableEndpoint: BasePricesDashboardStore.getDataTableEndpoint(),
        dateFormat: BasePricesDashboardStore.getDateFormat(),
        loading: BasePricesDashboardStore.getLoading(),
        readOnly: BasePricesDashboardStore.getReadOnly(),
        reservationSegments: BasePricesDashboardStore.getReservationSegments(),
        requestCleaningPath: BasePricesDashboardStore.getRequestCleaningPath(),
        timeFormat: BasePricesDashboardStore.getTimeFormat(),
        dateFormat: BasePricesDashboardStore.getDateFormat(),
      };
    }
  
    render() {
      
      var currentDate = this.state.currentDate
  
      if (this.props.currentDate && !this.state.afterMount) {
        currentDate = parseISO(this.props.currentDate)
      }
      return (
        <div className="housekeeping-status-board">
          <BasePricesDashboardHeader {...this.state} dateFormat={this.props.dateFormat} timeFormat={this.props.timeFormat} currentDate={currentDate} />
  
          <DataTable
            ref="dataTable"
            endpoint={this.state.dataTableEndpoint}
            no_data_text={I18n.t('none')}
            currency_unit={I18n.t('number.currency.format.unit')}
            delimiter={I18n.t('number.currency.format.delimiter')}
            separator={I18n.t('number.currency.format.separator')}
            date_format={this.state.dateFormat}
            time_format={this.state.timeFormat}
          />
  
          {this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
        </div>
      );
    }
  
    _onChange() {
      this.setState(this.getStateFromStores());
    }
  
  };
  
  export default BasePricesDashboard